export default {
      id: "growth-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#growth",
      toString: function () {
        return this.url;
      }
    }